import { useEffect, useState } from "react";
import { KEY_LANGUAGE_SESSION_STORAGE } from "../utils/constants";

export const LANGUAGE_CHANGED_EVENT = "alm-language-changed";

const getCurrentLanguage = () =>
  sessionStorage.getItem(KEY_LANGUAGE_SESSION_STORAGE) || "en";

const useSelectedLanguage = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(getCurrentLanguage);

  useEffect(() => {
    const handleLanguageChanged = (event) => {
      const nextLanguage = event?.detail?.language || getCurrentLanguage();
      setSelectedLanguage(nextLanguage);
    };

    window.addEventListener(LANGUAGE_CHANGED_EVENT, handleLanguageChanged);
    return () => {
      window.removeEventListener(LANGUAGE_CHANGED_EVENT, handleLanguageChanged);
    };
  }, []);

  return selectedLanguage;
};

export default useSelectedLanguage;
